<template>
	<div :class="['full-icon-button', emphasis]" @click="$emit('click', $event)">
		<svgicon class="icon" v-if="icon" :icon="icon" />
	</div>
</template>

<script>
	import ButtonView from './ButtonView'

	export default {
		extends: ButtonView,
		props: ['icon', 'emphasis']
	}
</script>

<style lang="scss" scoped>
	.full-icon-button {
		position: relative;
		cursor: pointer;
		width: 40px;
		height: 40px;
		background-color: #e6e6e6;
		border-radius: 50%;

		& > .icon {
			position: absolute;
			width: 20px;
			height: 20px;
			fill: #15161a;
			left: 10px;
			top: 10px;
		}

		&.primary {
			background-color: #f7223f;

			& > .icon {
				fill: #ffffff;
			}
		}
	}
</style>
